export const BUNDLES_REPOSITORY_ENDPOINTS = Object.freeze({
  requestBundle: `${process.env.GATSBY_BUNDLES_URL}`,
  requestRecommendation: `${process.env.GATSBY_API_POST_BUNDLE_RECOMMENDABLE}`,
  requestBundleDisclaimer: `${process.env.GATSBY_API_POST_BUNDLE_DISCLAIMER}`,
});


export const isBundlesRecommendationEnabled = () => {
  return !!process.env.GATSBY_FEATURE_BUNDLES_RECOMMENDATION_ENABLED;
};

export const isBundleDisclaimerEnabled = () => {
  return !!process.env.GATSBY_FEATURE_BUNDLE_DISCLAIMER_ENABLED;
}
